<template>
    <div class="home">
        <home-hero-component></home-hero-component>

        <div id="section-two-start"></div>
        <section class="features ptb100">
            <div class="container">

                <!-- Section Title -->
                <div class="section-title">
                    <h2>Why you should host with us</h2>
                </div>

                <div class="row">

                    <!-- Feature -->
                    <div class="col-md-4 feature">
                        <img :src="asset('/img/icons/cloud-hosting.svg')" alt="Free Website Migration"
                             class="feature-icon">
                        <img :src="asset('/img/icons/cloud-hosting.svg')" alt="Free Website Migration"
                             class="feature-back-icon">
                        <h4>Free Site Migration</h4>
                        <p class="pt10">Coming from another web host? Our support team will migrate your website over to our
                            servers free of charge.</p>
                    </div>

                    <!-- Feature -->
                    <div class="col-md-4 feature">
                        <img :src="asset('/img/icons/secure-server.svg')" alt="No downtime" class="feature-icon">
                        <img :src="asset('/img/icons/secure-server.svg')" class="feature-back-icon"
                             alt="No downtime">
                        <h4>No downtime</h4>
                        <p class="pt10">We optimize our servers and they are hosted in the best data centers, allowing us to
                            give a 99.9% up-time guarantee.</p>
                    </div>

                    <!-- Feature -->
                    <div class="col-md-4 feature">
                        <img src="/img/icons/transfer.svg" class="feature-icon" alt="Solid State Drive">
                        <img src="/img/icons/transfer.svg" class="feature-back-icon" alt="Solid State Drive">
                        <h4>Solid State Drives</h4>
                        <p class="pt10">Our hosting servers use Solid State Drives (SSD), which speed up your website page
                            load times by up to 300%.</p>
                    </div>

                    <!-- Feature -->
                    <div class="col-md-4 feature">
                        <img :src="asset('/img/icons/technical-support.svg')" class="feature-icon"
                             alt="Technical Support">
                        <img :src="asset('/img/icons/technical-support.svg')" class="feature-back-icon"
                             alt="Technical Support">
                        <h4>Technical Support</h4>
                        <p class="pt10">Our support staff is available 24/7/365 to assist you with any hosting-related
                            issues.</p>
                    </div>

                    <!-- Feature -->
                    <div class="col-md-4 feature">
                        <img :src="asset('/img/icons/high-perf-servers.svg')" class="feature-icon"
                             alt="High Perfomance Servers">
                        <img :src="asset('/img/icons/high-perf-servers.svg')" class="feature-back-icon"
                             alt="High Performance Servers">
                        <h4>High Performance Servers</h4>
                        <p class="pt10">Servers featuring Intel® Xeon processors, CloudLinux, Solid State Drives, Anti-DDoS
                            protection and 10Gbps ports.</p>
                    </div>

                    <!-- Feature -->
                    <div class="col-md-4 feature">
                        <img :src="asset('/img/icons/optimization.svg')" class="feature-icon"
                             alt="One Click Installation">
                        <img :src="asset('/img/icons/optimization.svg')" class="feature-back-icon"
                             alt="One Click Installation">
                        <h4>One Click Installation</h4>
                        <p class="pt10">Softaculous offers real fast auto installing of many popular scripts in one
                            click. </p>
                    </div>
                </div>

            </div>
        </section>

        <hosting-cta-section></hosting-cta-section>
    </div>
</template>

<script>
    export default {
        name: "Home",
        metaInfo: {
            meta: [{
                name: "description",
                content: "Affordable, Secure, reliable, fast performance for all your web hosting needs with 24/7 support and a 100% satisfaction... A Web Hosting Company That Grows With You..."
            }]
        }
    }
</script>

<style lang="scss" scoped>
    .features {
        background: #f6f6f6;

        .feature {
            padding-top: 25px;
            padding-bottom: 25px;

            h4 {
                font-weight: bold;
            }

            .feature-back-icon {
                position: absolute;
                height: 100px;
                top: 40px;
                left: 0;
                opacity: .07;
            }

            .feature-icon {
                height: 60px;
                padding-bottom: 10px;
                filter: hue-rotate(10deg) brightness(0.8)
            }
        }
    }

    @media screen and (max-width: 768px) {
        .features {

            // Odd children
            .feature:nth-child(odd) {
                .feature-back-icon {
                    right: 0;
                    left: unset;
                }
            }

            // Even children
            .feature:nth-child(even) {
                text-align: right;

                .feature-back-icon {
                    left: 0;
                    right: unset;
                }
            }
        }
    }
</style>